<div id="blazor-root"></div>
<hs-toolbar>
  <hs-toolbar-logo [logo]="'hs'"> </hs-toolbar-logo>
  <div hsToolbarTitle>{{ title }}</div>

  @if(isAuthenticated()) {
  <hs-toolbar-more-btn>
    <button hsProfileButton [generateButtonColor]="true" [hsMenuTrigger]="menu">
      {{ userInitials() }}
    </button>
  </hs-toolbar-more-btn>
  }

  <hs-toolbar-button-row>
    <button
      hsToolbarButton
      (click)="onThemingChanged()"
      [hsTooltip]="toggleThemeTooltip"
    >
      <hs-icon [width]="24" [height]="24" [innerHTML]="themeIcon()"></hs-icon>
    </button>
  </hs-toolbar-button-row>

  @if(!isAuthenticated()) {
  <hs-toolbar-button-row>
    <button hsToolbarButton (click)="onSettingsClicked()">
      <hs-icon [width]="24" [height]="24" [innerHTML]="settingsIcon"></hs-icon
      >{{ settingsLabel }}
    </button>
  </hs-toolbar-button-row>
  }
  <hs-toolbar-page-content>
    <hs-rail-nav [buttonGroups]="railNavButtonGroups" [bottomGroup]="railNavBottomGroup" #railNav>
      <div hsRailNavContent>
        <router-outlet></router-outlet>
      </div>
    </hs-rail-nav>
  </hs-toolbar-page-content>
</hs-toolbar>

<ng-template #menu>
  <hs-menu>
    <hs-menu-item-group>
      <hs-menu-item (click)="onProfileClicked()"
        ><div class="flex flex-row gap-2 items-center">
          <hs-icon
            [width]="24"
            [height]="24"
            [innerHTML]="iconProfile"
          ></hs-icon
          >{{ profileLabel }}
        </div></hs-menu-item
      >

      <hs-menu-item (click)="onSettingsClicked()"
        ><div class="flex flex-row gap-2 items-center">
          <hs-icon
            [width]="24"
            [height]="24"
            [innerHTML]="settingsIcon"
          ></hs-icon
          >{{ settingsLabel }}
        </div></hs-menu-item
      >
    </hs-menu-item-group>
    <hs-menu-item-group>
      <hs-menu-item (click)="onLogoutClicked()"
        ><div class="flex flex-row gap-2 items-center">
          <hs-icon [width]="24" [height]="24" [innerHTML]="iconLogout"></hs-icon
          >{{ logoutLabel }}
        </div></hs-menu-item
      ></hs-menu-item-group
    >
  </hs-menu>
</ng-template>
